import React from 'react';

const FormError = ({ message }) => {
    if (!message) return null;

    return (
        <div className="ow-form-error" role="alert">
            {message}
        </div>
    );
};

export default FormError;
